import React, { useState , useEffect} from 'react';

import db from "../../functions/firestore.js";
import { shuffleArray, getMovieInteres} from "../../functions/functions.js";
import Swipe from "../site/swiper.js";
import LazyLoad from "react-lazyload";
import Movieinfo from "../movie/movieinfo.js";

export default function Movies(props) {
    const [ movies , setMovies] = useState('');
    const [ slideshow , getForSlideshow] = useState('');
    const [ feelings , setfeelings] = useState([]);
    const [ modalOpen, setModalOpen] = useState(false);
    const [ movieData , setMovieData] = useState('');

    const [ error, setError] = useState('');

    const fetchMovies = async() => {
      await db.collection("movies").where('enes_review', '==', 1).get().then(response => {
        const movielimit = response.size;
        const fetchedMovies = [];
        let countpreffered = 0;
        // MOVIES
        response.docs.forEach(document => {
          db.collection("movies").doc(document.id).collection('mfeelings').get().then(response => {
            //MOVIE FEELINGS
            const fetchedMoviesFeelings = [];
            const fetchedMovieUsers = [];
            
            response.docs.forEach(document2 => {
              const docData = document2.data();
              fetchedMoviesFeelings.push({name: docData["mfeeling_name"] , icon: docData["mfeeling_icon"]});
              fetchedMovieUsers.push({name: docData["mfeeling_name"] , doc_id: document2.id , userid: docData["user_id"]});
            });

            //SORTING FEELINGS
            const uniqueArray = a => [...new Set(a.map(o => JSON.stringify(o)))].map(s => JSON.parse(s));
            const unique = uniqueArray(fetchedMoviesFeelings);            
            let moviefeeling = unique.map(value => [{feeling: value, length: fetchedMoviesFeelings.filter(str => str.name === value.name).length}]);
            if(moviefeeling){ moviefeeling.sort((a, b) => (a[0].length > b[0].length) ? -1 : 1);  }


            //SORT ALL MOVIE FEELIGNS 
            const procentege = getMovieInteres(document.data(), moviefeeling , props.mood, props.genre);
            var fetchedMovie = {
              id: document.id,
              ...document.data(),
              moviefeelings: moviefeeling,
              allmoviefeelings: fetchedMovieUsers,
              procenteges: procentege
            };

            if(procentege > 0){
              fetchedMovies.unshift(fetchedMovie); 
              countpreffered += 1;
            }else {
              fetchedMovies.push(fetchedMovie);
            }
            //response.size
            if(fetchedMovies.length === movielimit){ 
              (countpreffered > 0) ? countpreffered = countpreffered : countpreffered = 30;
              shuffleArray(fetchedMovies , countpreffered);
              getForSlideshow([...slideshow , fetchedMovies.slice(10, 20)]);
              setMovies([...movies , fetchedMovies]);
            }
            
          });
        });
      }).catch(function(err) {
        setError('Error: Getting movies! Quota exceeded');
      })
    }

    //FETCHING ALL FEELINGS
    const fetchfeelings = async() => {
      await db.collection("feelings").get().then(querySnapshot => {
        const docs = querySnapshot.docs.map(doc => doc.data());
        setfeelings(docs);
      }).catch(function(err) {
        setError('Error: Getting movies! Quota exceeded');
      })
    }

    function handleChange(modalChange) { setModalOpen(modalChange); }
    const openModal = (data) => { setModalOpen(true); setMovieData(data); };
 

    useEffect(() => {
      fetchMovies();
      fetchfeelings();
    }, [])

    return (
      <div>
        {error?
          <div className="row">
            <div className="col-md-6 offset-md-3">
              <div className="alert alert-danger alert-box" role="alert">
                <h4 className="alert-heading">Error loading!</h4>
                <p style={{color: '#155724'}}>{error}</p>
                <hr />
                <p style={{color: '#155724'}} className="mb-0">Fixing issues in progress.</p>
              </div>
            </div>
          </div>
        :
        <div>
          <div>
          <Swipe data = {slideshow} datafeelings = {feelings} />
          </div>
          <div className = "movies">
            <Movieinfo key={movieData.title} modalvisible = {modalOpen} data = {movieData} datafeelings = {feelings} onChange={handleChange} />
            <div className = "container-fluid">
              <div className = "row rowmovies">
              {
                movies[0] && movies[0].map((data,index)=>{
                  return(
                  <div key={data.id} className="preview">
                    <a href="#" onClick={(e) => { e.preventDefault(); openModal(data); }}>
                    {data.procenteges > 0 ?
                      <img className="card" src={data.movie_thumbnail} />
                    :  
                      <LazyLoad height={192} width={341} once><img className="card" src={data.movie_thumbnail} /></LazyLoad>
                    }
              
                    </a>
                    <h4 className="text-center">{data.title} ({data.procenteges} %)</h4>
                  </div>
                  )
                })
              }
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    )
}

